import { Component, Input } from "@angular/core";
import { WebCustomer } from "../../../models";

@Component({
  selector: "app-customer-address",
  templateUrl: "./customer-address.component.html"
})
export class CustomerAddressComponent
{

  @Input()
  public customer: WebCustomer;

  constructor() { }

}
